import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import styles from "./InstagramGrid.module.scss";
import InstagramGridContent from "./InstagramGridContent.model";

import { ElfsightWidget } from "react-elfsight-widget";
import combineClasses from "helpers/combine-classes";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";


const InstagramGrid: FunctionComponent<InstagramGridContent> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <ElfsightWidget widgetId="c7350b04-4493-4b64-ac9e-0e482f6d7862" />
        </section>
    );
};

export default InstagramGrid;